import LoadingSpinner from '@/components/ui/loading'
import { useAuthContext } from '@/context'
import { useQueryMe } from '@/services/auth/queries'
import { ReactElement, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

type Props = {
    component: ReactNode
}

const PrivateRouteWrapper = ({ component }: Props): ReactElement => {
    const { loggedIn } = useAuthContext()
    const location = useLocation()
    const { isLoading } = useQueryMe()

    const isProtectedPath = ['/login', '/register', '/magic'].some(path => location.pathname.includes(path))

    if (isLoading && isProtectedPath) {
        return <LoadingSpinner />
    }

    if (!loggedIn && isProtectedPath) {
        const redirectPath = encodeURIComponent(location.pathname + location.search)
        return <Navigate to={`/login?redirect_url=${redirectPath}`} replace />
    }

    if (!loggedIn && !location.pathname.includes('/magic')) {
        const redirectPath = encodeURIComponent(location.pathname + location.search)
        return <Navigate to={`/login?redirect_url=${redirectPath}`} replace />
    }

    return <>{component}</>
}

export default PrivateRouteWrapper
